/**
 * Declared in both home and srp experiment modules because each page fetches only its own
 * domain's list — a single declaration would register the flag without bucketing either page.
 */
export const OPEN_TEXT_SEARCH_EXPERIMENT = 'car-merch-ui-open-text-search';
